/**
 * 兼容层：将 TiptapRichEditor 导出为 RichEditor，保持向后兼容
 * 这样可以无缝替换旧的 Editable.js 编辑器
 */
import { TiptapRichEditor, TiptapRichEditorProps, TiptapRichEditorRef } from './index';

export type RichEditorProps = TiptapRichEditorProps;
export type RichEditorRef = TiptapRichEditorRef;
export const RichEditor = TiptapRichEditor;
